import * as React from "react";

import { CircularProgress, Typography } from "@material-ui/core";

import { RequestState, Status } from "../Utility/useHttp";

interface IProps<T> {
    readonly errorMessage: string;
    readonly request: RequestState<T>;
}

export function RequestProgress<T>(props: IProps<T>): React.ReactElement | null {
    const request = props.request;

    if (request.status === Status.Error) {
        return <Typography color="error">{props.errorMessage}</Typography>;
    } else if (request.status === Status.Loading) {
        return <CircularProgress size="1rem" />;
    }

    return null;
}